import { Box, Grid, Stack, SxProps, Theme, Typography } from "@mui/material"
import { useIsMobile } from "../hooks"

type props = {
    image: string,
    title: string,
    text: string[],
}

const StartupRowStyle: Record<string, SxProps<Theme>> = {
    captionTitle: (theme: Theme) => ({
        color: theme.palette.secondary.main,
        fontSize: "27px",
        textAlign: "left",
        marginBottom: "20px",
    }),
    captionTitleMobile: (theme: Theme) => ({
        color: theme.palette.secondary.main,
        fontSize: "20px",
        textAlign: "center",
        marginBottom: "20px",
    }),
    captionText: {
        fontSize: "22px",
        textAlign: "left",
    },
    captionTextMobile: {
        fontSize: "16px",
        textAlign: "left",
    },
    captionImageMobile: {
        padding: "20px",
        img: {
            width: "100%",
            height: "auto",
        },
    },
    captionImage: {
        padding: "20px",
        img: {
            width: "100%",
            height: "auto",
        },
    },
}

export default function StartupRow({image, title, text}: props) {
    const {isMobile} = useIsMobile();

    if (isMobile) return <Stack spacing={1} marginTop={"20px"} marginBottom={"20px"}>
        {/* titolo */}
        <Typography sx={StartupRowStyle.captionTitleMobile}>
            {title}
        </Typography>

        {/* immagine */}
        <Box sx={StartupRowStyle.captionImageMobile}>
            <img src={image}/>
        </Box>

        {/* elenco testi */}
        {
            text.map((descText) => <Typography sx={StartupRowStyle.captionTextMobile}>
                {descText}
            </Typography>)
        }
    </Stack>

    return <>
        {/* immagine */}
        <Grid item md={4}>
            <Box sx={StartupRowStyle.captionImage}>
                <img src={image}/>
            </Box>
        </Grid>
        
        <Grid item md={isMobile ? 4 : 8} marginBottom={"50px"}>
            {/* titolo */}
            <Typography sx={StartupRowStyle.captionTitle}>
                {title}
            </Typography>
            
            {/* elenco testi */}
            {
                text.map((descText) => <Typography sx={StartupRowStyle.captionText}>
                    {descText}
                </Typography>)
            }
        </Grid>
    </>
}